import type { CalendarEvent } from '../../types/api';
import { getPrimaryTagColor } from '../../utils/tagColors';

const EVENT_FILL_BLEND = 0.18;

export function getScheduleEventColor(
  event: CalendarEvent,
  tagColors?: Record<string, string> | null,
): string {
  if (event.type === 'reminder' && event.tags) {
    const tagColor = getPrimaryTagColor(event.tags, tagColors);
    if (tagColor) return tagColor;
  }
  if (event.type === 'google') return '#EA4335';
  if (event.sent) return '#8E8E93';
  if (event.isPaused) return '#FF9500';
  if (event.isRecurring) return '#3478F6';
  return '#34C759';
}

export function getScheduleEventFillColor(color: string): string {
  const match = color.trim().match(/^#?([0-9a-fA-F]{6})$/);
  if (!match) return `${color}30`;

  const hex = match[1];
  const red = parseInt(hex.slice(0, 2), 16);
  const green = parseInt(hex.slice(2, 4), 16);
  const blue = parseInt(hex.slice(4, 6), 16);
  const blendWithWhite = (channel: number) => Math.round(255 + (channel - 255) * EVENT_FILL_BLEND);
  return `rgb(${blendWithWhite(red)}, ${blendWithWhite(green)}, ${blendWithWhite(blue)})`;
}
